import { render, staticRenderFns } from "./ModulesView.vue?vue&type=template&id=11f6463e"
import script from "./ModulesView.vue?vue&type=script&lang=js"
export * from "./ModulesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports